import React, { memo, useEffect, useState } from "react";
import { AvatarInfo } from "components";
import MemberDetail from "./MemberDetail";

const GroupMemberListItem = ({
  data,
  groupDetail,
  onCloseParent,
  dataAdmin,
  accountBlockArray,
  isAdminGroup,
  onRemoveMember,
}) => {
  const [selectedMember, setSelectedMember] = useState();

  const onClickDetail = item => {
    setSelectedMember(item);
  };

  const onClose = () => {
    setSelectedMember();
  };

  const onCloseAll = () => {
    onClose();
    onCloseParent();
  };

  const handleRemoveMember = memberId => {
    onClose();
    onRemoveMember(memberId);
  };

  useEffect(() => {
    if (data && selectedMember?.id) {
      const newSelectedData = data.find(item => item.id === selectedMember.id);
      if (newSelectedData) setSelectedMember(newSelectedData);
    }
  }, [data]);

  const isShowMemberDetail = selectedMember && selectedMember.id;

  return (
    <>
      {data?.map((item, index) => (
        <AvatarInfo
          key={`${item.avatarId}-${index}`}
          onClick={() => onClickDetail(item)}
          secondTitle={item.phone}
          title={item.name}
          avatar={{ avatarId: item.avatarId, name: item.name }}
          button={true}
        />
      ))}
      {isShowMemberDetail && (
        <MemberDetail
          data={selectedMember}
          groupDetail={groupDetail}
          onClose={onClose}
          onCloseParent={onCloseAll}
          dataAdmin={dataAdmin}
          accountBlockArray={accountBlockArray}
          isAdminGroup={isAdminGroup}
          onRemoveMember={handleRemoveMember}
        />
      )}
    </>
  );
};

export default memo(GroupMemberListItem);
